export interface UserPredictionModel {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
}
